import React from "react";
import { Modal, ModalBody, Button, Spinner } from "reactstrap";

/**
 * Confirmation popup shown before a master record is deleted.
 *
 * It has two states:
 *  - confirm : "Are you sure ..." with Cancel / Yes, Delete
 *  - blocked : the API refused the delete because the record is already used
 *              somewhere else. We then show that message and only an Ok button.
 */
const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
  title = "Delete Record",
  message = "Are you sure you want to delete this record? This action cannot be undone.",
  blockedMessage = "",
  dependencies = [],
}) => {
  const isBlocked = Boolean(blockedMessage);

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered backdrop="static">
      <ModalBody className="text-center p-4">
        <div className="mb-3">
          <i
            className={
              isBlocked
                ? "mdi mdi-alert-circle-outline text-warning"
                : "mdi mdi-trash-can-outline text-danger"
            }
            style={{ fontSize: "56px", lineHeight: 1 }}
          />
        </div>

        <h5 className="mb-2">{isBlocked ? "Unable to Delete" : title}</h5>

        <p className="text-muted mb-3">
          {isBlocked ? blockedMessage : message}
        </p>

        {isBlocked && dependencies?.length > 0 && (
          <ul className="list-unstyled text-start d-inline-block mb-3">
            {dependencies.map((dependency) => (
              <li key={dependency.label} className="text-muted">
                <i className="mdi mdi-circle-small" />
                {dependency.label}
                {dependency.count ? ` — ${dependency.count} record(s)` : ""}
              </li>
            ))}
          </ul>
        )}

        <div className="d-flex justify-content-center gap-2">
          {isBlocked ? (
            <Button color="primary" onClick={onClose}>
              Ok
            </Button>
          ) : (
            <>
              <Button color="secondary" onClick={onClose} disabled={isDeleting}>
                Cancel
              </Button>
              <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
                {isDeleting ? (
                  <>
                    <Spinner size="sm" className="me-1" /> Deleting...
                  </>
                ) : (
                  "Yes, Delete"
                )}
              </Button>
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteConfirmModal;
